var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('core-list-view-page', {
    attrs: {
      "fetch-items": _vm.fetchItems,
      "fetchErrorMessage": 'DeviceDriver.details.snacks.fetchDriversFailed',
      "external-fetch-params": {
        accountFilterIsReady: _vm.accountFilterIsReady,
        selectedAccounts: _vm.selectedAccounts,
        cacheBuster: _vm.cacheBuster
      },
      "table-headers": _vm.tableHeaders,
      "headline": _vm.hideHeader === false ? _vm.$i18n_t('DeviceDriver.list.title') : undefined,
      "subtitle": _vm.hideHeader === false ? _vm.$i18n_t('DeviceDriver.list.subtitle') : undefined,
      "row-href": item => _vm.getSingleDriverUrl(item.id),
      "header-buttons": _vm.hideHeader === false ? _vm.headerButtons : undefined,
      "show-header": _vm.hideHeader === false,
      "empty-state-icon": "fal fa-sensor-on",
      "empty-state-title": _vm.$i18n_t('DeviceDriver.list.emptyState.title'),
      "empty-state-description": _vm.$i18n_t('DeviceDriver.list.emptyState.description')
    },
    on: {
      "copyPaste": () => _vm.$router.push('/virtual-device-drivers/new?source=clipboard'),
      "button:create": () => _vm.$router.push('/virtual-device-drivers/new'),
      "update:total-count": function ($event) {
        return _vm.$emit('update:total-count', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons-after",
      fn: function () {
        return [_vm.hideHeader === false ? _c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterIsReady = true;
            }
          }
        }) : _vm._e(), _c('core-prompt', {
          attrs: {
            "title": _vm.$i18n_t('DeviceDriver.list.deleteItem.prompt.title'),
            "open": _vm.itemIdToBeDeleted !== null,
            "buttons": [{
              text: _vm.$i18n_t('DeviceDriver.list.deleteItem.prompt.cancelButton.label'),
              emit: 'cancel'
            }, {
              text: _vm.$i18n_t('DeviceDriver.list.deleteItem.prompt.deleteButton.label'),
              color: _vm.color,
              emit: 'delete'
            }]
          },
          on: {
            "cancel": function ($event) {
              _vm.itemIdToBeDeleted = null;
            },
            "delete": _vm.onDeleteItemConfirm
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DeviceDriver.list.deleteItem.prompt.text')) + "\n    ")])];
      },
      proxy: true
    }])
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };